export default __webpack_public_path__ + "static/Cards-378ada13389a2d341a67c2d31672946c.png";